import {ChangeDetectionStrategy, Component, Injectable, input, output} from "@angular/core";
import {Meldingstype, SystemMeldingModell, SystemmeldingRessursClient, Varseltype} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {FormaterZonedDateTimePipe} from "felles-ng2/pipes/FormaterZonedDateTimePipe";
import {HtmlFormatertKomponent} from "web-ng2/delt/komponenter/html-formatert/html-formatert";
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'administrasjon-melding',
    templateUrl: 'melding.html',
    styleUrl: 'melding.scss',
    imports: [FormaterZonedDateTimePipe, HtmlFormatertKomponent, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdministrasjonMeldingKomponent {
    static ajsSelector = 'administrasjonMelding';

    melding = input.required<SystemMeldingModell>();
    slettet = output<SystemMeldingModell>();
    opprettFraMal = output<SystemMeldingModell>();

    constructor(private avhengigheter: AdministrasjonMeldingAvhengigheter) {}

    async slettMelding() {
        await this.avhengigheter.slett(this.melding().id);
        this.slettet.emit(this.melding());
    }

    meldingstype(meldingstype: Meldingstype): string {
        switch (meldingstype) {
            case Meldingstype.mal: return 'Mal';
            case Meldingstype.loggInnBankId: return 'Innlogging med BankID';
            case Meldingstype.loggInnHoved: return 'Innlogging';
            case Meldingstype.applikasjonHoved: return 'Generell melding i applikasjon';
            case Meldingstype.detteErNyttForMedlem: return 'Dette er nytt for medlem';
            case Meldingstype.detteErNyttForAdmin: return 'Dette er nytt for administrator';
            case Meldingstype.detteErNyttForTesting: return 'Dette er nytt for testing';
        }
    }

    varseltype(): string {
        switch (this.melding().varseltype) {
            case Varseltype.advarsel: return 'Advarsel';
            case Varseltype.feil: return 'Feil';
            case Varseltype.info: return 'Info';
            default: return '';
        }
    }

}

@Injectable({providedIn: 'root'})
export class AdministrasjonMeldingAvhengigheter {
    constructor(private ressurs: SystemmeldingRessursClient) {}

    slett(id: string): Promise<void> {
        return this.ressurs.slett(id).somPromise();
    }
}
